__turbopack_context__.v({
  "shimmer": "meikIW_shimmer",
  "store": "meikIW_store",
  "stores": "meikIW_stores",
  "text-bar-sweep": "meikIW_text-bar-sweep",
});
